// import { useMutation, useQuery } from "@tanstack/react-query";
import { useEffect } from 'react';
import { useQueryParams } from '../HelperFunctions/Hooks/useQueryParams';
import { useCustomerApi } from '../../hooks/useCustomerApi';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from '../Stateless/SnackBarProvider';

export const useGetAllCustomer = ({
  isMainScreen = false,
  initialData,
}: {
  initialData?: any;
  isMainScreen?: boolean;
  key?: any;
}) => {
  const { query, queryhash, setFilters, filters, setQuery, updateQuery } =
    useQueryParams<any>({
      isMainScreen,
      initialData,
    });
  const { getAllCustomer } = useCustomerApi();
  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: ['getCustomer', query.page, query.limit, query.search],
    queryFn: () => {
      return getAllCustomer(query);
    },
  });

  useEffect(() => {
    if (queryhash) {
      refetch();
    }
  }, [queryhash]);

  const isLoading = isFetching || isRefetching;

  return {
    data,
    isLoading,
    query,
    setQuery,
    filters,
    setFilters,
    updateQuery,
  };
};

export const UseCreateUser = () => {
  const { createUser } = useCustomerApi();
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();

  return useMutation({
    mutationFn: (data: any) => createUser(data),
    onSuccess: (response) => {
      queryClient.invalidateQueries({ queryKey: ['getCustomer'] });
      showMessage(
        response?.message || 'Customer created successfully',
        'success'
      );
    },
    onError: (error: any) => {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'Failed to create customer';
      showMessage(errorMessage, 'error');
    },
  });
};

export const UseEditUser = () => {
  const { editCustomerById } = useCustomerApi();
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: any }) =>
      editCustomerById(id, data),
    onSuccess: (response) => {
      queryClient.invalidateQueries({ queryKey: ['getCustomer'] });
      showMessage(
        response?.message || 'Customer updated successfully',
        'success'
      );
    },
    onError: (error: any) => {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'Failed to update customer';
      showMessage(errorMessage, 'error');
    },
  });
};
